var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{attrs:{"fluid":"","id":"printMe"}},[_c('b-row',[_c('b-col',[_vm._t("top-left")],2),_c('b-col',[_vm._t("top-right")],2)],1),_c('b-row',[_c('b-col',[_c('h4',[_vm._v("Selected Model: "+_vm._s(_vm.sideBarModel.model.PcnCatalogNumber))])])],1),_c('b-row',[_c('b-col',[_vm._t("bottom")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }